import { render } from "./FontWeight.vue?vue&type=template&id=b130cab0&scoped=true&ts=true"
import script from "./FontWeight.vue?vue&type=script&lang=ts"
export * from "./FontWeight.vue?vue&type=script&lang=ts"

import "./FontWeight.vue?vue&type=style&index=0&id=b130cab0&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b130cab0"]])

export default __exports__